import AdminJelentkezokTabla from "../components/admin/admin_jelentkezok/AdminJelentkezokTabla";

function AdminJelentkezok() {
  return (
    <div className="pt-24 lg:pt-28 lg:px-10 xl:pt-32 xl:px-24">
      <AdminJelentkezokTabla />
    </div>
  );
}

export default AdminJelentkezok;
